import Skeleton from "react-loading-skeleton";

export default function LoadingSkeleton({ props }) {
  return <Skeleton {...props} />;
}
